import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

import ChartStockFinacial from '../../chart/chartStockFinacial';

import * as _ from 'lodash';
import { getQ } from 'utils';
import { log } from 'utils';

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function KhaNangSinhLoi(props) {
  const { freqActive, setFreqActive, fsRatio, t, theme } = props;

  const [tongTaisan, setTongTaiSan] = React.useState([]);
  const [noNganHan, setNoNganHan] = React.useState([]);
  const [noDaiHan, setNoDaiHan] = React.useState([]);
  const [vonChuSH, setVonChuSH] = React.useState([]);

  const preFSRatio = usePrevious(fsRatio);

  React.useEffect(() => {
    if (fsRatio && !_.isEqual(fsRatio, preFSRatio)) {
      processData();
    }
  }, [fsRatio]);

  function processData() {
    const _bienLoiNhuanGop = _.map(fsRatio, 'GR_MARGIN');
    const _bienLoiNhuanRong = _.map(fsRatio, 'NET_MARGIN');
    const _roa = _.map(fsRatio, 'ROA');
    const _roe = _.map(fsRatio, 'ROE');

    const _time = _.map(fsRatio, 'REPORT_DATE');

    let __bienLoiNhuanGop = [],
      __bienLoiNhuanRong = [],
      __roa = [],
      __roe = [];

    // log(_time);

    for (let index = 0; index < _time.length; index++) {
      if (freqActive === 'Q') {
        __bienLoiNhuanGop.push({
          name: getQ(_time[index]),
          value: _bienLoiNhuanGop[index],
        });
        __bienLoiNhuanRong.push({
          name: getQ(_time[index]),
          value: _bienLoiNhuanRong[index],
        });
        __roa.push({
          name: getQ(_time[index]),
          value: _roa[index],
        });
        __roe.push({
          name: getQ(_time[index]),
          value: _roe[index],
        });
      } else {
        let st = new Date(_time[index].replace(/-/g, "/"));
        __bienLoiNhuanGop.push({
          name: st.getFullYear() + '',
          value: _bienLoiNhuanGop[index],
        });
        __bienLoiNhuanRong.push({
          name: st.getFullYear() + '',
          value: _bienLoiNhuanRong[index],
        });
        __roa.push({
          name: st.getFullYear() + '',
          value: _roa[index],
        });
        __roe.push({
          name: st.getFullYear() + '',
          value: _roe[index],
        });
      }
    }
    setTongTaiSan(__bienLoiNhuanGop);
    setNoNganHan(__bienLoiNhuanRong);
    setNoDaiHan(__roa);
    setVonChuSH(__roe);
  }

  // log(fsRatio);

  return (
    <div
      className="d-flex flex-column w-100 h-100 p-2 analysis-overview"
      style={{ background: 'var(--bg_card_chart)', borderRadius: '2px' }}
    >
      <div className="d-flex pb-2" style={{ flexDirection: 'row-reverse' }}>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Y' ? 'active' : '')
          }
          onClick={() => setFreqActive('Y')}
        >
          {t('algo.ptcp.txt-Year')}
        </Button>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Q' ? 'active' : '')
          }
          onClick={() => setFreqActive('Q')}
        >
          {t('algo.ptcp.txt-Quarter')}
        </Button>
      </div>
      <div
        className="d-grid h-100"
        style={{
          gridTemplateColumns: 'repeat(2, minmax(0px, 1fr))',
          gap: '15px',
        }}
      >
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Gross-margin')}
            data={tongTaisan}
            subText={t('algo.ptcp.txt-unit-per')}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Net-margin')}
            data={noNganHan}
            subText={t('algo.ptcp.txt-unit-per')}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={'ROA'}
            data={noDaiHan}
            subText={t('algo.ptcp.txt-unit-per')}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={'ROE'}
            data={vonChuSH}
            subText={t('algo.ptcp.txt-unit-per')}
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(KhaNangSinhLoi);
